import React from "react";
import { formatLocationLabel, workTypeLabel } from "../../../helpers/estimates";
import {
  computeLocationTotal,
  formatCurrency,
} from "../../../helpers/estimateTotals";
import {
  LOCATION_CARD_STYLE,
  LOCATION_HEADER_STYLE,
  LOCATION_NAME_STYLE,
  TOTAL_CARD_STYLE,
} from "../estimateStyles";
import { WorkTypeReviewSection } from "./WorkTypeReviewSection";

export function LocationReviewSection({ location, materialsCatalog }) {
  const workTypes = location.workTypes || [];
  const locationTotal = computeLocationTotal(location, materialsCatalog);
  const showLocationTotal = workTypes.some(
    (wt) => (wt.materials?.length || 0) > 0 || (wt.labour?.length || 0) > 0,
  );

  return (
    <div style={LOCATION_CARD_STYLE}>
      <div style={LOCATION_HEADER_STYLE}>
        <div style={LOCATION_NAME_STYLE}>
          {formatLocationLabel(location)}
        </div>
      </div>

      {location.is_default_scope && (
        <div style={{ opacity: 0.65, fontSize: "13px", marginBottom: "16px" }}>
          Job-wide location for mobilization, permits, and other scope not tied
          to a specific area.
        </div>
      )}

      {workTypes.length === 0 ? (
        <div style={{ opacity: 0.65, marginBottom: "14px", fontSize: "14px" }}>
          No work types in this location.
        </div>
      ) : (
        <>
          <div
            style={{
              fontWeight: 700,
              fontSize: "16px",
              marginBottom: "14px",
              color: "#e8dcc0",
            }}
          >
            Work Types ({workTypes.length})
          </div>

          {workTypes.map((workType) => (
            <WorkTypeReviewSection
              key={workType.estimate_feature_id}
              workType={workType}
              materialsCatalog={materialsCatalog}
            />
          ))}
        </>
      )}

      {showLocationTotal && (
        <div style={TOTAL_CARD_STYLE}>
          {workTypes.map((wt) => {
            const total = computeLocationTotal(
              { workTypes: [wt] },
              materialsCatalog,
            );
            if (total <= 0) return null;
            return (
              <div
                key={wt.estimate_feature_id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "14px",
                  marginBottom: "8px",
                  opacity: 0.85,
                }}
              >
                <span>{workTypeLabel(wt)}</span>
                <span>{formatCurrency(total)}</span>
              </div>
            );
          })}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "18px",
              fontWeight: 700,
              color: "#c9a84c",
              paddingTop: "12px",
              borderTop: "1px solid rgba(201,168,76,0.35)",
            }}
          >
            <span>Location Total</span>
            <span>{formatCurrency(locationTotal)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
